module.exports = __webpack_public_path__ + "img/img-16.df4835b0.png";